var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMaximizeVector = function SvgIconMaximizeVector(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4v2h4.59L17 13.58 18.41 15 26 7.41V12h2V4zM15 18.42 13.59 17 6 24.59V20H4v8h8v-2H7.41z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaximizeVector);
export { ForwardRef as ReactComponent };